import { render } from "./WizardPage.vue?vue&type=template&id=d17a420a"
import script from "./WizardPage.vue?vue&type=script&lang=js"
export * from "./WizardPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__